function updateCustomSellingPlans(container) {
    const productId = container.dataset.product;
    const prefix = container.dataset.prefix || "";
    const parent = container.closest('.wt__quick-buy,[data-section-id]');
    const productForm = [...parent.querySelectorAll('form[data-type="add-to-cart-form"]')].find(form => form.querySelector('input[name="product-id"]')?.value === productId);
    if (!productForm) {
        return;
    }
    const sellingPlanActive = container.querySelector(`input[name="${prefix}custom-selling-plan-toggle"]:checked`).value === '1';
    let sellingPlanSelected = container.querySelector(`input[name="${prefix}custom-selling-plan"]:checked`);
    if (sellingPlanActive && !sellingPlanSelected) {
        sellingPlanSelected = container.querySelector(`input[name="${prefix}custom-selling-plan"]`);
    }
    const priceElt = container.querySelector('[data-custom-selling-plans-price]');
    const compareAtPriceElt = container.querySelector('[data-custom-selling-plans-compare-at-price]');
    let sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
    if (!sellingPlanInput) {
        sellingPlanInput = document.createElement('input');
        sellingPlanInput.name = "selling_plan";
        sellingPlanInput.type = "hidden";
    }
    productForm.append(sellingPlanInput);

    if (sellingPlanSelected) {
        if (priceElt) {
            priceElt.textContent = sellingPlanSelected.dataset.price;
        }
        if (compareAtPriceElt) {
            compareAtPriceElt.textContent = sellingPlanSelected.dataset.compareAtPrice;
        }
    }

    if (sellingPlanActive) {
        sellingPlanInput.value = sellingPlanSelected.value;
    } else {
        sellingPlanInput.value = '';
    }
}

function initCustomSellingPlans(container) {
    updateCustomSellingPlans(container);
    container.addEventListener('change', () => {
        updateCustomSellingPlans(container);
    });
}

function prefixCustomSellingPlansContent(container, prefix) {
    container.setAttribute('data-prefix', prefix);
    container.querySelectorAll('input[type="radio"]').forEach(input => {
        input.setAttribute('name', `${prefix}${input.getAttribute('name')}`);
        input.setAttribute('id', `${prefix}${input.getAttribute('id')}`);
    });
    container.querySelectorAll('label').forEach(label => {
        label.setAttribute('for', `${prefix}${label.getAttribute('for')}`);
    });
}

document.querySelectorAll('[data-custom-selling-plans]').forEach((container) => {
    initCustomSellingPlans(container);
});
window.addEventListener("variantChangeEnd", function (e) {

    const parent = e.target.closest('[data-section-id]');
    const productHandle = e.target.dataset.productHandle;
    const variant = e.target.currentVariant?.id;

    document.querySelectorAll('[data-custom-selling-plans]').forEach((container) => {
        const thisProductHandle = container.dataset.productHandle;
        if (thisProductHandle !== productHandle) {
            return;
        }
        const thisParent = container.closest('[data-section-id]');
        if (thisParent !== parent) {
            return;
        }
        const sectionId = container.dataset.section;
        if (!sectionId) {
            return;
        }
        let url;
        if (thisParent) {
            url = new URL(window.location.href).pathname;
        } else if (!thisParent) {
            url = `${window.Shopify.routes.root}products/${productHandle}`;
        }
        fetch(`${url}?sections=${sectionId}&variant=${variant}`).then(response => response.json()).then(json => {
            const html = json[sectionId];
            const resultsMarkup = new DOMParser()
                .parseFromString(html, "text/html");
            const newContainer = resultsMarkup.querySelector('[data-custom-selling-plans]');

            if (!thisParent) {
                const prefix = 'quick-';
                prefixCustomSellingPlansContent(newContainer, prefix);
            }

            container.replaceWith(newContainer);

            initCustomSellingPlans(newContainer);
        });
    });
});
(function () {
  function fixTermsCheckbox() {
    const checkbox = document.querySelector(
      '.cart__footer-terms-checkbox input[type="checkbox"],' +
      '.cart__footer-terms input[type="checkbox"],' +
      '.cart-footer-terms input[type="checkbox"],' +
      '.cart__terms input[type="checkbox"],' +
      '.cart-terms input[type="checkbox"]'
    );

    if (checkbox) {
      // Enlève le blocage HTML
      checkbox.removeAttribute('required');

      // Force l'acceptation (le thème attend souvent un "checked" + event)
      checkbox.checked = true;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      checkbox.dispatchEvent(new Event('input', { bubbles: true }));
    }

    // Certains thèmes désactivent le bouton checkout tant que non coché
    const checkoutBtn = document.querySelector(
      'button[name="checkout"], .cart__checkout-button, .cart__checkout, .drawer__checkout button'
    );
    if (checkoutBtn) checkoutBtn.disabled = false;
  }

  // Au chargement
  document.addEventListener('DOMContentLoaded', fixTermsCheckbox);

  // Et quand le cart drawer se met à jour dynamiquement
  const obs = new MutationObserver(() => fixTermsCheckbox());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
